import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AccountService, AlertService } from '@app/_services';
import { MustMatch } from '@app/_helpers';
import { EmailVerificationService } from '@app/_services/email-verification.service';

enum TokenStatus {
  Validating,
  Valid,
  Invalid,
}

@Component({
  templateUrl: 'reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  TokenStatus = TokenStatus;
  tokenStatus = TokenStatus.Validating;
  token: string;
  form: FormGroup;
  loading = false;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService,
    private emailService: EmailVerificationService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            this.passwordComplexityValidator,
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );

    const token = this.route.snapshot.paramMap.get('token') || '';
    this.emailService.checkToken(token).subscribe({
      next: (res) => {
        if (res.valid) {
          // this.tokenValid = true;
          this.token = token;
          this.tokenStatus = TokenStatus.Valid;
        } else {
          // this.errorMessage = res.message || 'Invalid or expired token. Please request a new password reset.';
          this.tokenStatus = TokenStatus.Invalid;
        }
      },
      error: (err) => {
        // this.errorMessage = 'An error occurred. Please try again later.';
        this.tokenStatus = TokenStatus.Invalid;
      },
    });

    // remove token from url to prevent http referer leakage
    // this.router.navigate([], { relativeTo: this.route, replaceUrl: true });

    // this.accountService
    //   .validateResetToken(token)
    //   .pipe(first())
    //   .subscribe({
    //     next: () => {
    //       this.token = token;
    //       this.tokenStatus = TokenStatus.Valid;
    //     },
    //     error: () => {
    //       this.tokenStatus = TokenStatus.Invalid;
    //     },
    //   });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  passwordComplexityValidator(control: any) {
    const password = control.value || '';
    const hasNumber = /\d/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>+\-_‘’[\]\\\/`~]/.test(
      password
    );

    const isValid =
      hasNumber && hasUpperCase && hasLowerCase && hasSpecialCharacter;

    return isValid ? null : { passwordComplexity: true };
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.accountService
      .resetPassword(
        this.token,
        this.f.password.value,
        this.f.confirmPassword.value
      )
      .pipe(first())
      .subscribe({
        next: () => {
          this.alertService.success(
            'Password reset successful, you can now login',
            { keepAfterRouteChange: true }
          );
          this.router.navigate(['/account/login'], { relativeTo: this.route });
        },
        error: (error) => {
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }
}
